module.exports = __webpack_public_path__ + "static/trio_vans.69be3a84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trio_vans.jpg
// module id = 399
// module chunks = 190574249368808 245136550379825